import { SelectItem } from 'primeng/api';
import { InventoryTransferStatus } from '../enums';

export class InventoryTransferStatusLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Submitted', value: InventoryTransferStatus.Submitted },
            { label: 'Pending Confirmation', value: InventoryTransferStatus.PendingConfirmation },
            { label: 'Completed', value: InventoryTransferStatus.Completed },
            { label: 'Cancelled', value: InventoryTransferStatus.Cancelled },
        ];
    }

    static getLabel(status: InventoryTransferStatus): string {
        return this.getLookup().find(s => s.value === status)?.label || status || '';
    }
}
